import type { RouteLocationNormalizedGeneric } from 'vue-router';
import { useConsentSelfServiceUrl } from '~/composables/academy/useConsentSelfServiceUrl';
import { useNoConsentFallbackUrl } from '~/composables/academy/useNoConsentFallbackUrl';
import log from '~/utils/log';

/**
 * Sends a user without the Academy consent to the section's fallback story, which explains what is
 * required and carries the call to action into the Self Service. Sections without a story configured
 * go to the Self Service directly.
 */
export const redirectToConsentFlow = (
    config: ConfigStoryblok | null | undefined,
    to: RouteLocationNormalizedGeneric
) => {
    const fallbackUrl = useNoConsentFallbackUrl(config);

    if (fallbackUrl) {
        log.debug(`[consent] Redirecting to the no-consent fallback: ${fallbackUrl}`);
        return navigateTo(fallbackUrl);
    }

    const selfServiceConsentsUrl = useConsentSelfServiceUrl(to).value;

    log.debug(`[consent] No fallback story configured, redirecting to the self-service consents.`);
    return navigateTo(selfServiceConsentsUrl, { external: true });
};
